var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_c('div', {
    staticClass: "s-container"
  }, [_c('Header', {
    attrs: {
      "meta": _vm.meta,
      "page-title": _vm.moduleConfig.page_title,
      "page-image": _vm.moduleConfig.page_image,
      "page-kv-image": _vm.moduleConfig.page_kv_image,
      "header-section": _vm.moduleConfig.header_section
    }
  }), !_vm.isIndividualTab ? _c('Tabs', {
    attrs: {
      "tabs": _vm.tabs,
      "currentTab": _vm.currentTab
    }
  }) : _vm._e(), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)], 1), _c('Alert', {
    ref: "alert"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }